import { useState, useMemo } from 'react'
import moment from 'moment'

const parseValorFormatado = (str) => {
    const s = (str || '').toString().replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.')
    const n = parseFloat(s)
    return Number.isNaN(n) ? 0 : n
}

const obterValorParaOrdenacao = (item, accessor, tipo) => {
    const raw = item?.[accessor]
    if (raw === null || raw === undefined || raw === '') return null
    if (tipo === 'numero') {
        const n = Number(raw)
        return Number.isNaN(n) ? 0 : n
    }
    if (tipo === 'moeda') return parseValorFormatado(raw)
    if (tipo === 'data') {
        const formato = String(raw).length > 10 ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'
        const m = moment(raw, formato, true)
        return m.isValid() ? m.valueOf() : 0
    }
    return String(raw).toLowerCase()
}

const comparar = (a, b, direcao) => {
    if (a === null && b === null) return 0
    if (a === null) return 1
    if (b === null) return -1
    if (a < b) return direcao === 'asc' ? -1 : 1
    if (a > b) return direcao === 'asc' ? 1 : -1
    return 0
}

const useOrdenacao = (itens) => {
    const [ordenacao, setOrdenacao] = useState({ accessor: null, tipo: null, direcao: 'asc' })

    const alternar = (accessor, tipo) => {
        setOrdenacao(prev => {
            if (prev.accessor !== accessor) return { accessor, tipo, direcao: 'asc' }
            if (prev.direcao === 'asc') return { accessor, tipo, direcao: 'desc' }
            return { accessor: null, tipo: null, direcao: 'asc' }
        })
    }

    const itensOrdenados = useMemo(() => {
        if (!ordenacao.accessor || !itens) return itens || []
        const copia = [...itens]
        copia.sort((x, y) => comparar(
            obterValorParaOrdenacao(x, ordenacao.accessor, ordenacao.tipo),
            obterValorParaOrdenacao(y, ordenacao.accessor, ordenacao.tipo),
            ordenacao.direcao
        ))
        return copia
    }, [itens, ordenacao])

    const obterClasseTh = (accessor) => {
        if (ordenacao.accessor !== accessor) return 'ordenavel'
        return `ordenavel ordenamento_${ordenacao.direcao}`
    }

    return { itensOrdenados, ordenacao, alternar, obterClasseTh }
}

export default useOrdenacao
